class TabbedMenu extends HTMLElement {
  connectedCallback() {
    this.triggers = this.querySelectorAll('[data-tab-trigger]');
    this.panels = this.querySelectorAll('[data-tab-panel]');

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('pointerenter', () => this.activate(trigger));
      trigger.addEventListener('focus', () => this.activate(trigger));
      trigger.addEventListener('click', (event) => {
        this.activate(trigger);
        event.preventDefault(); // remove this line if tab should navigate too
      });
    });
  }

  activate(trigger) {
    const targetId = trigger.dataset.panel;
    if (!targetId) return;

    this.triggers.forEach((t) => {
      t.closest('.tabbed-mega-menu__tab-item')?.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    trigger.closest('.tabbed-mega-menu__tab-item')?.classList.add('is-active');
    trigger.setAttribute('aria-selected', 'true');

    this.panels.forEach((panel) => panel.classList.remove('is-active'));
    this.querySelector(`#${targetId}`)?.classList.add('is-active');
  }
}

customElements.define('tabbed-menu', TabbedMenu);